import { render, staticRenderFns } from "./UserAccountsTable.vue?vue&type=template&id=3ba8960e&scoped=true"
import script from "./UserAccountsTable.vue?vue&type=script&lang=js"
export * from "./UserAccountsTable.vue?vue&type=script&lang=js"
import style0 from "./UserAccountsTable.vue?vue&type=style&index=0&id=3ba8960e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba8960e",
  null
  
)

export default component.exports